// Styles
import { numberToPx, pxToNumber } from "@ms/uno-utilities/lib/local/StyleUtilities";
import { backgroundColorHover, backgroundColorNeutralPrimary, flexChildSizeFixed, flexParent, flexParentCenterAll, styleButtonAsDiv } from "../../../../utilities/Mixin.styles";
import { taskCardContentWidth } from "../boardView/BoardViewCommon.styles";
const labelTagMenuButtonHeight = "32px";
const labelTagMaxWidthOverride = "234px";
const labelMenuMargin = "4px";
export const getStyles = ({ theme })=>{
    const root = [
        "taskContextMenu",
        backgroundColorNeutralPrimary(theme)
    ];
    const labelMenuItem = [
        "labelMenuItem",
        styleButtonAsDiv,
        flexParent(),
        {
            paddingLeft: labelMenuMargin,
            paddingRight: numberToPx(pxToNumber(labelMenuMargin) * 2),
            alignItems: "center",
            cursor: "pointer",
            width: "100%",
            height: labelTagMenuButtonHeight,
            "> i": [
                flexChildSizeFixed(),
                flexParent(),
                flexParentCenterAll,
                {
                    margin: `0px ${labelMenuMargin}`
                }
            ],
            ":focus, :hover": [
                backgroundColorHover(theme)
            ]
        }
    ];
    const contextualMenu = {
        root: {
            maxHeight: "280px",
            maxWidth: taskCardContentWidth
        },
        subComponentStyles: {
            menuItem: {
                root: {
                    boxSizing: "border-box"
                }
            }
        }
    };
    const labelTag = {
        root: [
            flexChildSizeFixed(),
            {
                marginLeft: labelMenuMargin,
                maxWidth: labelTagMaxWidthOverride
            }
        ]
    };
    return {
        root,
        labelMenuItem,
        subComponentStyles: {
            contextualMenu,
            labelTag
        }
    };
};
